import { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

const Wrap = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`;

const Unit = styled.div`
  min-width: 64px;
  text-align: center;
  padding: 0.6rem 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: ${({ theme }) => theme.radii.sm};
  background: rgba(0, 0, 0, 0.35);
  overflow: hidden;
`;

const pop = keyframes`
  0% { transform: translateY(-100%) scale(0.8); opacity: 0; }
  60% { transform: translateY(6%) scale(1.08); opacity: 1; }
  100% { transform: translateY(0) scale(1); opacity: 1; }
`;

const Value = styled.span`
  display: block;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 1.6rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.gold};
  line-height: 1.1;
  animation: ${pop} 420ms cubic-bezier(0.34, 1.56, 0.64, 1);

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Label = styled.span`
  display: block;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: rgba(255, 255, 255, 0.75);
`;

function diffParts(target) {
  const ms = Math.max(new Date(target).getTime() - Date.now(), 0);
  const totalSeconds = Math.floor(ms / 1000);
  return {
    dias: Math.floor(totalSeconds / 86400),
    horas: Math.floor((totalSeconds % 86400) / 3600),
    min: Math.floor((totalSeconds % 3600) / 60),
    seg: totalSeconds % 60
  };
}

function Countdown({ target }) {
  const [parts, setParts] = useState(() => diffParts(target));

  useEffect(() => {
    const id = setInterval(() => setParts(diffParts(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  return (
    <Wrap role="timer" aria-label="Cuenta regresiva al evento">
      {Object.entries(parts).map(([label, value]) => (
        <Unit key={label}>
          <Value key={value}>{String(value).padStart(2, '0')}</Value>
          <Label>{label}</Label>
        </Unit>
      ))}
    </Wrap>
  );
}

export default Countdown;
